import { defaultMetaAdminRequest } from '../routesSetup';
import RequestIsForView from '../../lib/pages/RequestIsForView.vue';
import YourDetailsView from '../../lib/pages/YourDetailsView.vue';
import PatientDetailsView from '../../lib/pages/PatientDetailsView.vue';
import ProblemDetailsView from '../../lib/pages/ProblemDetailsView.vue';
import SummaryView from '../../lib/pages/SummaryView.vue';
import SubmittedSuccessfullyView from '../../lib/pages/SubmittedSuccessfullyView.vue';
import {
  formAdminRequestDetails,
  formPatientDetailsYou,
  formReporterType,
  formYourDetails,
} from '@/data/forms';
import { DefaultLayout } from '../../lib/layouts/layouts';
import { RouteRecordRaw } from 'vue-router';
import MedicalWarningView from '../../lib/pages/MedicalWarningView.vue';

const adminRequestChildren: RouteRecordRaw[] = [
  {
    path: 'medical-warning',
    name: 'medical-warning-ar',
    component: MedicalWarningView,
    meta: {
      ...defaultMetaAdminRequest,
      layoutPageTitle: "Check it's not an emergency",
      pageTitle: "Check it's not an emergency",
      nhsAppActions: {
        setBackAction: 'SERVICES',
        goToPage: 'SERVICES',
        showBackNhsApp: true,
        showBackNhsAppWeb: false,
      },
    },
  },
  {
    path: 'request-is-for',
    name: 'admin-request-is-for',
    component: RequestIsForView,
    meta: {
      ...defaultMetaAdminRequest,
      formConfig: formReporterType,
      layoutComponent: DefaultLayout,
      layoutPageTitle: null,
    },
  },
  {
    path: 'your-details',
    name: 'admin-your-details',
    component: YourDetailsView,
    meta: {
      ...defaultMetaAdminRequest,
      formConfig: formYourDetails,
    },
  },
  {
    path: 'patient-details',
    name: 'admin-patient-details',
    component: PatientDetailsView,
    meta: {
      ...defaultMetaAdminRequest,
      formConfig: formPatientDetailsYou,
    },
  },
  // NB: NHS app can land here.
  // ?from=nhsApp
  {
    path: 'admin-problem-details',
    name: 'admin-problem-details',
    component: ProblemDetailsView,
    meta: {
      ...defaultMetaAdminRequest,
      formConfig: formAdminRequestDetails,
      requiresValidPatient: true,
      pageTitle: 'Request details',
      layoutPageTitle: 'Request details',
      nhsAppActions: {},
    },
  },
  {
    path: 'summary',
    name: 'admin-summary',
    component: SummaryView,
    meta: {
      ...defaultMetaAdminRequest,
      layoutPageTitle: 'Check your answers',
      requiresValidPatient: true,
      nhsAppActions: {
        setBackAction: 'GO_BACK',
        goToPage: 'GO_BACK', //
        showBackNhsApp: true,
        showBackNhsAppWeb: true,
      },
    },
  },
  {
    path: 'submitted-successfully',
    name: 'admin-submitted-successfully',
    component: SubmittedSuccessfullyView,
    meta: {
      ...defaultMetaAdminRequest,
      backButton: false,
      layoutPageTitle: null,
      pageTitle: 'Request submitted successfully',
      nhsAppActions: {
        showBackNhsApp: false,
        showBackNhsAppWeb: false,
      },
    },
  },
];

export default adminRequestChildren;
